import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { Routes } from '../../../../AppRoutes';
import { Icon } from '../../../../components';

export const GameManagementLayout = (Component: FC<any>) => (props: any) => {
  return (
    <div className='game-management-layout'>
      <div className='TabLinks'>
        <NavLink to={Routes.OrdersPage.path}>
          <Icon.OrderIcon />
          Orders
        </NavLink>

        <NavLink
          to={Routes.SupplierListPage.path}

          // isActive={() => {
          //   return props?.location?.pathname?.includes('/game-management/supplier');
          // }}
        >
          <Icon.SupplierIcon />
          Suppliers
        </NavLink>

        <NavLink
          to={Routes.GameListPage.path}

          // isActive={() => {
          //   return props?.location?.pathname?.includes('/game-management/game');
          // }}
        >
          <Icon.GameIcon />
          Games
        </NavLink>
      </div>
      <Component {...props} />
    </div>
  );
};
